import { connect } from 'react-redux'
import SettingManager from './component'
import { actions, attributes, commands } from '../../../../imports'

// todo: state Remove the knowledge of state from here
// either by getting access to a selector,
// or by adding this information to the backend state
// and use middleware to get informed
function mapStateToProps(state) {
    return {
        languages: attributes.languages,
        activeServer: state.servers.active, // state.servers.active
        servers: state.servers.list, // state.servers.list
        users: state.users.list, // state.users.list
        regex: attributes.regex,
        setToken: commands.launcherSetToken,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setClientVersion: (version) => {
            dispatch(actions.setClientVersion(version))
        },
        setLauncherVersion: (version) => {
            dispatch(actions.setLauncherVersion(version))
        },
        setUiVersion: (version) => {
            dispatch(actions.setUiVersion(version))
        },
        saveSettings: (settings) => {
            dispatch(actions.saveSettings(settings))
        },
        showError: (notification) => {
            dispatch(actions.showError(notification))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/SettingManager/index.js